// extracted by mini-css-extract-plugin
export default {"overlay":"context-menu__overlay___YN45j","items":"context-menu__items___e2n_j"};